import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import Radium, { StyleRoot } from 'radium';
import {RealCampusHdr} from './RealCampusHdr';
import {RealCampusFooter} from './RealCampusFooter';
import {RealCampusFeedback} from './RealCampusFeedback';
import * as TgccRequest from '../tgccRequest';
import { MerchComponent } from '../Components/MerchComponent';




const homepageStyle : React.CSSProperties = {
    width:'100%',
}
const merchDiv: React.CSSProperties = {
    display:'flex',
    flexWrap:'wrap',
}
const merchWrapper: React.CSSProperties = {
    width:'100%',
    display:'flex',
    justifyContent:'center',
}
const schoolHdr: React.CSSProperties = {
    fontFamily:'Lulo',
    textAlign:'center',
    color:'rgb(97, 96, 96)',
    textTransform:'uppercase'
}
const orderDiv: React.CSSProperties = {
    width:'100%',
    height:'100px',
    backgroundColor:'#4D5561',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    marginTop:"3%",
    flexDirection:'column'
}
const need: React.CSSProperties = {
    color:'white',
    fontFamily:"BarlowMedium",
    fontSize:'17px'
}
const start: React.CSSProperties = {
    color:"white",
    fontFamily:'Lulo',
    textDecoration:'underline',
    fontSize:'17px',
    cursor:'pointer'
}

class Props extends Tgcc.BaseProps{
    ActiveProof: Tgcc.Proof;
}
type StateType = {
    Themes: Tgcc.MerchandisingTheme[];
}
const DIVISION: string = 'realcampus';
class _RealCollectionListView extends React.Component <Props, any > {
    state = {
        Themes:null
    }

    componentDidMount(){
        TgccRequest.getMerchandisingThemes(DIVISION,(themes: Tgcc.MerchandisingTheme[]) => this.loadThemes(themes))

    }

    loadThemes = (themes: Tgcc.MerchandisingTheme[]) => {
        this.setState({Themes:themes})
    }

    handleClick = (theme:Tgcc.MerchandisingTheme) => {
        browserHistory.push(Tgcc.Routes.RealCollection(theme.theme))
    }
    getMerchThemes(){
        var themes = new Array()
        for (var i in this.state.Themes){
            var theme : Tgcc.MerchandisingTheme = this.state.Themes[i]
            themes.push(<MerchComponent key={i} theme={theme} onSelect={this.handleClick}></MerchComponent>)
        }
        return themes

    }
    requestSchool = () => {
        browserHistory.push(Tgcc.Routes.RealCampusSchoolRequest)
    };
    render() {
        return (
                <div style={homepageStyle}>
                    <div id="homepage"></div>
                    <RealCampusHdr />
                    <RealCampusFeedback state={this.props.state} />
                    <h1 style={schoolHdr}>Shop Your School</h1>
                    <div style={orderDiv}>
                        <div style={need}>Don't see your school?</div>
                        <div style={start} onClick={this.requestSchool}>REQUEST TO ADD!</div>
                    </div>
                    <div style={merchWrapper}>
                        <div style={merchDiv}>
                            {this.getMerchThemes()}               
                        </div>
                    </div>
                    <RealCampusFooter state={this.props.state} />
                </div>
        );
    }
}


var radiumRealCollectionListView = Radium(_RealCollectionListView);

const mapStateToProps = (state: Tgcc.GlobalState) => { 
    return { state:state}
};
export var RealCollectionListView = connect(mapStateToProps)(radiumRealCollectionListView);



